import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import Typography from "@material-ui/core/Typography";

import { TRV_ACCOUNT_DELETE_REQUEST_URL, COLOR_RED, COLOR_BLUE } from "../../config";
import makeApiRequest from "../../utils/axios/new-axios";
import { showErrorAlert } from "../../store/actions/alerts";
import ComponentLoader from "../../components/loader/ComponentLoader";
import { usePageTitle } from "../../utils/pageTitle";
import UserChip from "../../components/user/UserChip";
import { fromUnixtime } from "../../utils/time";


const useStyles = makeStyles(theme => ({
    paper: {
        width: "100%",
        overflowX: "auto",
        marginBottom: theme.spacing(2),
        padding: "15px"
    }
}));

const getReason = (type) => {
    let reason = "Other";
    switch (type) {
        case 1:
            reason = "App Not Useful";
            break;
        case 2:
            reason = "Privacy Concerns";
            break;
        case 3:
            reason = "Account Hacked";
            break;
        default:
            reason = "Other";
            break;
    }
    return reason;
}

export default function AccountDeleteRequest() {
    const classes = useStyles();
    const dispatch = useDispatch();
    usePageTitle("Account Delete Request");

    const [requests, setRequests] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        makeApiRequest({
            url: TRV_ACCOUNT_DELETE_REQUEST_URL.url,
            method: TRV_ACCOUNT_DELETE_REQUEST_URL.method,
        }).then(response => {
            setRequests(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            dispatch(
                showErrorAlert(
                    "Fetch Error : " +
                    (!!error.response
                        ? `${error.response.status}! - ${error.response.data.errorMessage}`
                        : error.message)
                )
            );

        })
        // eslint-disable-next-line
    }, []); // [] is required to make sure that it runs only once



    return (
        <Container style={{ marginTop: "20px", padding: "10px" }}>
            <h3> Account Delete Requets </h3>
            <ComponentLoader isLoading={isLoading} />
            {!isLoading &&
                <>
                    {requests && requests.length > 0 ? (
                        <Paper className={classes.paper}>
                            <Table className={classes.table} size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Req ID</TableCell>
                                        <TableCell>User</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Reason</TableCell>
                                        <TableCell>User Comment</TableCell>
                                        <TableCell>Requested On</TableCell>
                                        <TableCell>Deleted By</TableCell>
                                        <TableCell>Comment</TableCell>
                                        <TableCell>Deleted On</TableCell>
                                        <TableCell>Request Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {requests.map(req => {
                                        return (
                                            <TableRow key={req.id}>
                                                <TableCell>{req.id}</TableCell>
                                                <TableCell>
                                                    {!!req.name ? (<UserChip
                                                        user={{
                                                            id: req.userId,
                                                            name: req.name,
                                                            username: req.username,
                                                            type: 2
                                                        }}
                                                    />) : `Deleted User - ${req.userId}`}

                                                </TableCell>
                                                <TableCell>{req.email}</TableCell>
                                                <TableCell>{getReason(req.type)}</TableCell>
                                                <TableCell>{req.userComment}</TableCell>
                                                <TableCell>{fromUnixtime(req.requestedOn)}</TableCell>
                                                <TableCell>{req.deletedBy &&
                                                    <UserChip
                                                        user={{
                                                            id: req.deletedBy.id,
                                                            name: req.deletedBy.name,
                                                            username: req.deletedBy.username
                                                        }}
                                                    />
                                                }</TableCell>
                                                <TableCell>{req.comment}</TableCell>
                                                <TableCell>{req.deletedOn && fromUnixtime(req.deletedOn)}</TableCell>
                                                <TableCell>
                                                    <Chip
                                                        size="small"
                                                        variant="outlined"
                                                        label={req.status === 1 ? "Deleted" : "Requested"}
                                                        className={classes.chip}
                                                        style={{ backgroundColor: req.status === 1 ? COLOR_BLUE : COLOR_RED }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}

                                </TableBody>
                            </Table>
                        </Paper>
                    ) : (
                        <Typography align="center">No requests found !!</Typography>
                    )}
                </>
            }
        </Container>
    );
}
